import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { AlumnosSection } from '../components/AlumnosSection';
import { CourseContentSection } from '../components/CourseContentSection';
import { TestimonialsBanner } from '../components/TestimonialsBanner';
import { TestimonialsFeatures } from '../components/TestimonialsFeatures';
import { BonusSection } from '../components/BonusSection';
import { FAQ2Section } from '../components/FAQ2Section';
import { TestimonialsMasonrySection } from '../components/TestimonialsMasonrySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-brand-bg" data-id="element-256">
      <HeroSection data-id="element-257" />
      <CaseStudySection data-id="element-258" />
      <PricingSection data-id="element-259" />

      <AlumnosSection data-id="element-260" />
      <CourseContentSection data-id="element-261" />
      <TestimonialsBanner data-id="element-262" />
      <TestimonialsFeatures data-id="element-263" />
      <BonusSection data-id="element-264" />
      <TestimonialsSection data-id="element-265" />
      <TestimonialsMasonrySection data-id="element-266" />
      <FAQ2Section data-id="element-267" />
      <FinalCTASection data-id="element-268" />
    </main>;
}